import { isEmpty } from 'underscore';

import { BaseSurvey } from '../base-survey';
import { surveyStatus } from '../survey-status';
import { CopilotAssetRecommendationSatisfactionSurveyView } from './view';
import { validateCopilotAssetRecommendationSatisfactionTriggerCondition } from '../utils';

export class CopilotAssetRecommendationSatisfactionSurvey extends BaseSurvey {
  getSurveyName = () => 'CopilotAssetRecommendationSatisfactionSurvey';

  getSurveyId = () => 'ea62ec33-5c98-4894-86eb-b012a6e7e92d';

  validateTriggerCondition = () => validateCopilotAssetRecommendationSatisfactionTriggerCondition(this, 'CopilotAssetRecommendationSatisfactionTrigger');

  onSurveySubmit = () => {
    const newSurveyState = {
      status: surveyStatus.SUBMIT,
      nextShownDate: this.SurveyPreferenceService.getDaysAfter(180),
      requiredModifyNumber: 500,
    };

    this.SurveyPreferenceService.setSurveyState({
      surveyName: this.getSurveyName(),
      surveyState: newSurveyState,
    });

    window.survey.CopilotAssetRecommendationSatisfactionTrigger = false;
    delete window.survey.CopilotRecommendationsSurveyCustomParams;
  };

  onSurveyDismiss = () => {
    window.survey.CopilotAssetRecommendationSatisfactionTrigger = false;
    delete window.survey.CopilotRecommendationsSurveyCustomParams;

    const surveyState = this.SurveyPreferenceService.getSurveyState({
      surveyName: this.getSurveyName(),
    });

    let newSurveyState = {};
    if (!isEmpty(surveyState)) {
      const { status } = surveyState;
      switch (status) {
        case surveyStatus.FIRST_DISMISS:
          // set new state to second-dismiss and next shown date to 30 days
          newSurveyState = {
            status: surveyStatus.SECOND_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(30),
            requiredModifyNumber: 100,
          };
          break;
        case surveyStatus.SECOND_DISMISS:
          // set new state to third-dismiss and next shown date to 60 days
          newSurveyState = {
            status: surveyStatus.THIRD_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(60),
            requiredModifyNumber: 300,
          };
          break;
        case surveyStatus.THIRD_DISMISS:
          // set new state to third-dismiss and next shown date to 180 days
          newSurveyState = {
            status: surveyStatus.THIRD_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(180),
            requiredModifyNumber: 500,
          };
          break;
        case surveyStatus.FOURTH_DISMISS:
        case surveyStatus.INIT:
        case surveyStatus.SUBMIT:
        default:
          // for all others, set new state to init and next shown date to 7 days
          newSurveyState = {
            status: surveyStatus.FIRST_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(7),
            requiredModifyNumber: 50,
          };
          break;
      }
    } else {
      // new cycle, set new state to first-dismiss and next shown date to 7 days
      newSurveyState = {
        status: surveyStatus.FIRST_DISMISS,
        nextShownDate: this.SurveyPreferenceService.getDaysAfter(7),
        requiredModifyNumber: 50,
      };
    }

    this.SurveyPreferenceService.setSurveyState({
      surveyName: this.getSurveyName(),
      surveyState: newSurveyState,
    });
  };

  getSurveyComponent = () => CopilotAssetRecommendationSatisfactionSurveyView;

  getSurveyCustomParams = () => window.survey.CopilotRecommendationsSurveyCustomParams;
}
